import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
} from '@mui/material';

const TermsPage: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" gutterBottom align="center">
        Terms & Conditions
      </Typography>
      <Typography variant="h6" color="text.secondary" paragraph align="center" sx={{ mb: 6 }}>
        Please read these terms carefully before using our services
      </Typography>

      <Paper sx={{ p: 4 }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            1. Food Parcel Orders
          </Typography>
          <List>
            <ListItem>
              <ListItemText
                primary="Eligibility"
                secondary="Food parcels are available to individuals and families in need. Proof of address and identification may be required."
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="Order Limits"
                secondary="One food parcel per household per week. Additional parcels may be available in special circumstances."
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="Collection"
                secondary="Food parcels must be collected during designated collection times. Uncollected parcels may be redistributed."
              />
            </ListItem>
          </List>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            2. Donations
          </Typography>
          <List>
            <ListItem>
              <ListItemText
                primary="Monetary Donations"
                secondary="All monetary donations are used to support our food parcel program and community initiatives."
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="Food Donations"
                secondary="We accept non-perishable food items that are within their use-by date and in good condition."
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="Tax Deductions"
                secondary="Donations may be tax-deductible. Please consult with your tax advisor for specific information."
              />
            </ListItem>
          </List>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            3. Privacy Policy
          </Typography>
          <List>
            <ListItem>
              <ListItemText
                primary="Information Collection"
                secondary="We collect personal information necessary to provide our services and maintain records."
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="Information Usage"
                secondary="Personal information is used only for the purpose of providing our services and is not shared with third parties without consent."
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="Data Protection"
                secondary="We implement appropriate security measures to protect your personal information."
              />
            </ListItem>
          </List>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box>
          <Typography variant="h5" gutterBottom>
            4. Contact Information
          </Typography>
          <Typography paragraph>
            For any questions regarding these terms and conditions, please contact us:
          </Typography>
          <List>
            <ListItem>
              <ListItemText
                primary="Email"
                secondary="info@newlifefoodbarn.org"
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="Phone"
                secondary="(123) 456-7890"
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="Address"
                secondary="123 Food Barn Street, Community City, 12345"
              />
            </ListItem>
          </List>
        </Box>
      </Paper>
    </Container>
  );
};

export default TermsPage; 